import React, { useEffect, useRef, useState } from "react";
// import Header from '../header/header'
import { useDispatch, useSelector } from "react-redux";
// import { addPortfolioApi, getServiceApi } from '../../redux/portfolio/portfolio';
import { ArrowDown, ArrowRight } from 'lucide-react';
import toast from "react-hot-toast";
import {
  addPortfolioApi,
  getServiceApi,
  UserPortfolioApi,
} from "../../../redux/portfolio/portfolio";
import Header from "../../header/header";
import { useNavigate } from "react-router-dom";
import { setInitialuserDetail } from "../../../redux/auth/auth";

export default function Portfolio() {
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state.auth.userDetail);
  const portFolioList = useSelector((state) => state.portfolio.portFolioList);
  const userPortfolio = useSelector((state) => state.portfolio.userPortfolio);
  const userPortFolioList = useSelector(
    (state) => state.portfolio.userPortFolioList
  );
  const dispatch = useDispatch();
  // const [activeTab, setActiveTab] = useState("Porfolio");
  const [showModal, setShowModal] = useState(false);
  const [finalData, setFinalData] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [selectedindex, setSelectedindex] = useState(null);
  const [addedRows, setAddedRows] = useState({});
  const [highlightIndex, setHighlightIndex] = useState(null);
  const modalRef = useRef(null);
  useEffect(() => {
    dispatch(UserPortfolioApi(userDetail?.id));
  }, []);
  const handleSave = async (finalData) => {
    try {
      const result = await dispatch(addPortfolioApi(finalData));
      if (result) {
        dispatch(getServiceApi(userDetail?.id));
        toast.success(result?.payload?.message);
        setShowModal(false);
        setHighlightIndex(selectedindex);
        setTimeout(() => {
          setHighlightIndex(null);
        }, 700);
      }
    } catch (error) {
      console.error("Error adding portfolio:", error);
      toast.error(error.message);
    }




  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal]);
  useEffect(() => {
    dispatch(getServiceApi(userDetail?.id));
  }, [showModal]);
  const [inputs, setInputs] = useState({});
  const [errors, setErrors] = useState({});
  const handleInputChange = (index, field, value, recomQty) => {
    const numValue = Number(value);

    setSelectedindex(index ? index : null);
    if (numValue < 0) {
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: "Value cannot be negative",
        },
      }));
      return; // stop here, don't update inputs
    }

    if (recomQty && numValue > Number(recomQty) && field != "price") {
      // ❌ Greater than recommended qty not allowed
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: `Value should not exceed ${recomQty}`,
        },
      }));
      return; // stop here, don't update inputs
    }

    // ✅ Passed validation → update inputs and clear errors
    setInputs((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: "",
      },
    }));
  };



  // const handleInputChange = (index, field, value, recomQty) => {
  //   console.log(recomQty, "recomQty")
  //   setInputs((prev) => ({
  //     ...prev,
  //     [index]: {
  //       ...prev[index],
  //       [field]: value,
  //     },
  //   }));

  //   // Clear error on change
  //   setErrors((prev) => ({
  //     ...prev,
  //     [index]: {
  //       ...prev[index],
  //       [field]: "",
  //     },
  //   }));
  // };
  const handleAdd = async (stock, index, isInitial, mode) => {
    const stockInput = inputs[index] || {};
    // const qty = parseFloat(stockInput.qty);
    // const price = parseFloat(stockInput.price);
    const qty = parseFloat(String(stockInput.qty || "").replace(/,/g, ""));
    const price = parseFloat(String(stockInput.price || "").replace(/,/g, ""));
    let isValid = true;
    const validationErrors = {};

    if (!qty || isNaN(qty) || qty < 0) {
      validationErrors.qty = "Enter a valid quantity";
      isValid = false;
    }

    if (!price || isNaN(price) || price <= 0) {
      validationErrors.price = "Enter a valid buying price";
      isValid = false;
    }

    if (!isValid) {
      setErrors((prev) => ({
        ...prev,
        [index]: validationErrors,
      }));
      return;
    }

    // Clear errors
    setErrors((prev) => ({
      ...prev,
      [index]: {},
    }));

    // Build final data
    const finalData = {
      investedAmt: price * qty,
      allocation: stock.allocation,
      portfolioId: isInitial ? stock.portfolioId : stock.id,
      coCode: stock.coCode,
      symbol: stock.symbol,
      avgPrice: price,
      qty: qty,
      isInitial: isInitial,
      id: stock.id,
    };

    setFinalData(finalData);
    setShowModal(true);

    // ✅ Mark row as added so it won’t show Add button again
    if (mode === "add") {
      setAddedRows((prev) => ({ ...prev, [index]: true }));
    }

    // Clear inputs after action
    setInputs((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };



  // const handleAdd = async (stock, index, isInitial, mode) => {
  //   const stockInput = inputs[index] || {};
  //   const qty = parseFloat(stockInput.qty);
  //   const price = parseFloat(stockInput.price);

  //   let isValid = true;
  //   const validationErrors = {};

  //   // Validate Quantity
  //   if (!qty || isNaN(qty) || qty <= 0) {
  //     validationErrors.qty = "Enter a valid quantity";
  //     isValid = false;
  //   }

  //   // Validate Price
  //   if (!price || isNaN(price) || price <= 0) {
  //     validationErrors.price = "Enter a valid buying price";
  //     isValid = false;
  //   }

  //   if (!isValid) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [index]: validationErrors,
  //     }));
  //     return;
  //   }

  //   // Clear previous errors
  //   setErrors((prev) => ({
  //     ...prev,
  //     [index]: {},
  //   }));

  //   // Build and extract only required data fields

  //   const finalData = {
  //     investedAmt: mode == "edit" ? 0 : price * qty,
  //     allocation: stock.allocation,
  //     portfolioId: isInitial ? stock.portfolioId : stock.id,
  //     coCode: stock.coCode,
  //     symbol: stock.symbol,
  //     avgPrice: price,
  //     qty: qty,
  //     isInitial: isInitial,
  //     id: stock.id,
  //     // userId: userDetail.id
  //   };
  //   console.log(finalData, "finalData")
  //   setFinalData(finalData);
  //   setShowModal(true);

  //   // Clear inputs
  //   setInputs((prev) => ({
  //     ...prev,
  //     [index]: { qty: "", price: "" },
  //   }));
  // };
  return (
    <div className="text-body-emphasis bg-body-tertiary">
      <Header />

      {userDetail?.isWealthRegCompleted ? (
        <div className="py-3" style={{}}>
          <div className="container">
            <div className="row g-3">
              <div className="col-md-12">
                <div className="d-flex align-items-baseline">
                  <h1 className="fs-4 fw-bold text-capitalize mb-0">
                    🛍️ Portfolio
                  </h1>

                  <small className=" ms-2 fw-semibold">
                    <small> ({userPortfolio?.userList?.length} {userPortfolio?.userList?.length > 1 ? "Stocks" : "Stock"}) </small>
                  </small>
                  {/* (
                  {userPortfolio?.userList?.length > 0
                    ? userPortfolio?.userList?.length
                    : 0}
                  ) */}

                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div>
                  <small className="text-muted">Investment Amount</small>
                  <h5 className="mb-0">
                    {userPortfolio?.wealthInvestmentAmt?.toLocaleString(
                      "en-IN"
                    )}
                  </h5>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div>
                  <small className="text-muted">Available Funds</small>
                  <h5 className="mb-0">
                    {(
                      userPortfolio?.wealthInvestmentAmt -
                      userPortfolio?.totalInvestedAmt
                    )?.toLocaleString("en-IN")}
                  </h5>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div>
                  <small className="text-muted">Invested</small>
                  <h5 className="mb-0">
                    {userPortfolio?.totalInvestedAmt?.toLocaleString("en-IN")}
                  </h5>
                </div>
              </div>

              <div className="col-lg-2 col-md-3 col-6">
                <div>
                  <small className="text-muted">Current Value</small>
                  <h5 className="mb-0">
                    {userPortfolio?.totalCurrentValue?.toLocaleString("en-IN")}
                  </h5>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div>
                  <small className="text-muted">Current P&amp;L</small>
                  <div className="d-flex align-items-baseline">
                    <h5
                      className={
                        userPortfolio?.totalPnL >= 0 ? "text-green" : "text-red"
                      }
                    >
                      {userPortfolio?.totalPnL >= 0 ? "" : "-"}
                      {/* {userPortfolio?.totalPnL?.toFixed(2)} */}
                      {Math.abs(userPortfolio?.totalPnL || 0).toLocaleString(
                        "en-IN",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </h5>
                    <small
                      className={`ms-2 ${userPortfolio?.totalPnL >= 0 ? "text-green" : "text-red"
                        }`}
                    >
                      (
                      {/* {userPortfolio?.totalPnL >= 0 ? "" : "-"} */}
                      {userPortfolio?.totalNetChange || 0}
                      )
                    </small>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div>
                  <small className="text-muted">Day's P&amp;L </small>
                  <div className="d-flex align-items-baseline">
                    <h5
                      className={
                        userPortfolio?.totalDayProfit >= 0
                          ? "text-green"
                          : "text-red"
                      }
                    >
                      {userPortfolio?.totalDayProfit >= 0 ? "" : "-"}
                      {Math.abs(
                        userPortfolio?.totalDayProfit || 0
                      ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </h5>
                    <small
                      className={`ms-2 ${userPortfolio?.totalDayProfit >= 0
                        ? "text-green"
                        : "text-red"
                        }`}
                    >
                      ({userPortfolio?.totalDayProfit >= 0 ? "" : "-"}
                      {Math.abs(
                        userPortfolio?.todayNetChange || 0
                      ).toLocaleString("en-IN")}%
                      )
                    </small>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                {portFolioList?.length > 0 &&
                  <>
                    <h6 className="py-2 pe-3 text-body-link-body-emphasis bg-opacity-10 my-3 ">
                      🔔 New Recommendations
                    </h6>

                    <div
                      className="bg-opacity-10 p-3 border-bottom d-none d-md-block rounded-2"
                      style={{ background: "#15C77433" }}
                    >
                      <div className="row">
                        <div className="col-md-2 col-3 small">Scrip</div>
                        <div className="col-md-2 col-6 small">Fund Allocation</div>
                        <div className="col-md-1 col-3 small">CMP</div>
                        <div className="col-md-1 col-3 small">Recomm. Qty</div>
                        <div className="col-md-1 col-12 small text-muted">
                        </div>
                        <div className="col-md-2 col-6 small">Qty.</div>
                        <div className="col-md-2 col-6 small">Bought At</div>
                        <div className="col-md-1 col-12 small"></div>
                      </div>
                    </div>
                  </>
                }

                {portFolioList?.map((stock, index) => (
                  <>
                    <div
                      className=" bg-opacity-10 p-2 border-bottom"
                      style={{ background: "#15C77433" }}
                    >
                      <div
                        key={index}
                        className="row g-3 mb-2 align-items-center"
                      >
                        <div className="col-md-2 col-6">
                          <small className="text-muted d-block d-md-none">
                            Symbol
                          </small>
                          <h6 className="mb-0 fw-bold text-body-emphasis">
                            {stock.symbol}
                          </h6>
                          <span>{stock.name}</span>
                        </div>

                        <div className="col-md-2 col-6">
                          <small className="text-muted d-block d-md-none">
                            Fund Allocation
                          </small>
                          <span className="d-flex justify-content-between ">
                            <span>
                              ₹
                              {Number(stock.allocation_amount).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                              {/* <span className="ms-1">
                                ({stock.allocation}%)
                              </span> */}
                            </span>
                          </span>
                        </div>

                        <div className="col-md-1 col-6">
                          <small className="text-muted d-block d-md-none">
                            CMP
                          </small>
                          {/* <p className="mb-0">
                            {stock.ltp != null
                              ? Number(stock.ltp).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "--"}
                          </p> */}
                          <p className="mb-0">
                            {stock.currentPrice != null
                              ? Number(stock.currentPrice).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "--"}
                          </p>
                        </div>
                        <div className="col-md-1 col-6">
                          <small className="text-muted d-block d-md-none">
                            Recomm. Qty.
                          </small>
                          <p className=" mb-0">
                            {Math.floor(
                              stock.allocation_amount / stock.currentPrice
                            )?.toFixed(2)}
                          </p>
                        </div>
                        {/* <div className="col-md-1 col-12"> */}
                        <div className="col-md-1 col-12 d-flex justify-content-md-start justify-content-center">
                          {((stock.investedAmt == null || undefined && !addedRows[index]) || editIndex === index) && (
                            <>
                              <button
                                className="btn btn-outline-secondary rounded-2 d-none d-md-inline-flex align-items-center justify-content-center shadow-sm"
                                // style={{ width: "40px", height: "40px" }}
                                onClick={() => {
                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      qty: Math.floor(Number(stock.allocation_amount) / Number(stock.currentPrice)).toLocaleString("en-IN"),
                                      price: Number(stock.currentPrice).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  }));
                                }}
                              >
                                <ArrowRight size={18} />
                              </button>

                              <button
                                className="btn btn-outline-secondary rounded-2 d-flex d-md-none align-items-center justify-content-center shadow-sm"
                                // style={{ width: "40px", height: "40px" }}
                                onClick={() => {
                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      qty: Math.floor(Number(stock.allocation_amount) / Number(stock.currentPrice)).toLocaleString("en-IN"),
                                      price: Number(stock.currentPrice).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  }));
                                }}
                              >
                                <ArrowDown size={18} />
                              </button>
                            </>
                          )}
                        </div>
                        <div className="col-md-2 col-6">
                          <small className="text-muted d-block d-md-none">
                            Qty.
                          </small>
                          <input
                            type="text"
                            className={`form-control form-control-sm ${errors[index]?.qty ? "is-invalid" : ""
                              }`}
                            // placeholder="Qty"
                            value={inputs[index]?.qty || ""}
                            onChange={(e) =>
                              handleInputChange(index, "qty", e.target.value, Math.floor(
                                stock.allocation_amount / stock.ltp
                              ))
                            }
                          />
                          {errors[index]?.qty && (
                            <div className="invalid-feedback">
                              {errors[index].qty}
                            </div>
                          )}
                        </div>

                        <div className="col-md-2 col-6">
                          <small className="text-muted d-block d-md-none">
                            Bought At
                          </small>
                          <input
                            type="text"
                            className={`form-control form-control-sm ${errors[index]?.price ? "is-invalid" : ""
                              }`}
                            // placeholder="Bought At"
                            value={inputs[index]?.price || ""}
                            onChange={(e) =>
                              handleInputChange(index, "price", e.target.value, Math.floor(
                                stock.allocation_amount / stock.ltp
                              ))
                            }
                          />
                          {errors[index]?.price && (
                            <div className="invalid-feedback">
                              {errors[index].price}
                            </div>
                          )}
                        </div>

                        <div className="col-md-1 col-12">
                          <button
                            className="btn btn-sm  text-white w-100 bg-gradient"
                            onClick={() => handleAdd(stock, index)}
                            style={{ background: "#15C774" }}
                          >
                            <i className="fa fa-plus"></i> Add
                          </button>
                        </div>
                      </div>
                    </div>
                    <p className="d-block d-md-none"></p>
                  </>
                ))}
              </div>
            </div>
            {/* Tabs */}
            {userPortFolioList?.length > 0 && <div className="row mt-4 ">
              <div className="col-md-12">
                <div className="table-responsive mt-2 rounded-3 border">
                  <table
                    className="table table-hover align-middle mb-0"
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: 0,
                      "--bs-border-opacity": 0.3,
                      fontSize: "14px",
                    }}
                  >
                    <thead
                      className=" position-sticky top-0"
                      style={{ zIndex: 1 }}
                    >
                      <tr>
                        <th className="text-start" style={{ minWidth: "110px" }}>
                          <small className=" text-muted fw-normal">Scrip</small>
                        </th>
                        <th className="text-end" style={{ minWidth: "50px" }}>
                          <small className=" text-muted fw-normal">Qty.</small>
                        </th>
                        <th className="text-end" style={{ minWidth: "90px" }}>
                          <small className=" text-muted fw-normal">
                            Avg. cost
                          </small>
                        </th>
                        <th className="text-end" style={{ minWidth: "90px" }}>
                          <small className=" text-muted fw-normal">LTP</small>
                        </th>
                        <th className="text-end" style={{ minWidth: "110px" }}>
                          <small className=" text-muted fw-normal">
                            Invested
                          </small>
                        </th>
                        <th className="text-end" style={{ minWidth: "110px" }}>
                          <small className=" text-muted fw-normal">
                            Cur. val
                          </small>
                        </th>
                        <th className="text-end" style={{ minWidth: "150px" }}>
                          <small className=" text-muted fw-normal">
                            Overall P&amp;L
                          </small>
                        </th>
                        {/* <th className="text-end"><small className="text-muted text-muted fw-normal">Net chg.</small></th> */}
                        <th className="text-end" style={{ minWidth: "150px" }}>
                          <small className=" text-muted fw-normal">
                           Day's P&L
                          </small>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {userPortFolioList.map((stock, idx) => (
                        <tr key={idx}>
                          <td className="py-3">
                            <span className="mb-0 fw-bold">{stock.symbol}</span>
                            <div className="text-muted">{stock.name}</div>
                          </td>
                          <td className="py-2 text-end">
                            {stock.qty?.toLocaleString("en-IN")}
                          </td>
                          <td className="py-2 text-end">
                            {stock.avgPrice?.toLocaleString("en-IN")}
                          </td>
                          <td className="py-2 text-end">
                            {stock.ltp?.toLocaleString("en-IN")}
                          </td>
                          <td className="py-2 text-end">
                            {stock.investedAmt != null
                              ? Number(stock.investedAmt).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "--"}
                          </td>
                          <td className="py-2 text-end">
                            {stock.currentValue != null
                              ? Number(stock.currentValue).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "--"}
                          </td>
                          {/* <td className={`py-2 text-end text-${stock.netChange < 0 ? "danger" : "success"}`}>{stock.pnl?.toFixed(2)}<small className={`${stock?.netChange > 0 ? "text-green" : "text-red"} ms-1`}>({stock?.netChange?.toFixed(2)}%)</small></td> */}
                          <td
                            className={`py-2 text-end text-${stock.netChange < 0 ? "red" : "green"
                              }`}
                          >
                            {stock.pnl != null
                              ? Number(Math.ceil(stock.pnl)).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "--"}
                            <small
                              className={`ms-1 text-${stock?.netChange >= 0 ? "green" : "red"
                                }`}
                            >
                              (
                              {stock.netChange != null
                                ? Number(stock.netChange).toFixed(2)
                                : "--"}
                              %)
                            </small>
                          </td>
                          {/* <td className={`py-2 text-end text-${stock.netChange < 0 ? "danger" : "success"}`}>{stock.netChange?.toFixed(2)}</td> */}
                          {/* <td className={`py-2 text-end text-${stock?.dayChange?.amount < 0 ? "danger" : "success"}`}>
                            {Number(stock?.dayChange?.amount ?? 0).toFixed(2)}
                            <small className={`${Number(stock?.dayChange?.percent ?? 0) < 0 ? "text-red" : "text-green"} ms-1`}>
                              ({Number(stock?.dayChange?.percent ?? 0).toFixed(2)}%)
                            </small>
                          </td> */}
                          <td
                            className={`py-2 text-end text-${stock?.dayChange?.amount < 0
                              ? "red"
                              : "green"
                              }`}
                          >
                            {stock?.dayChange?.amount != null
                              ? Number(stock.dayChange.amount).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "--"}
                            <small
                              className={`ms-1 text-${stock?.dayChange?.percent < 0
                                ? "red"
                                : "green"
                                }`}
                            >
                              (
                              {stock?.dayChange?.percent != null
                                ? Number(stock.dayChange.percent).toFixed(2)
                                : "--"}
                              %)
                            </small>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {showModal && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div
                      className="modal-content text-center rounded-4 shadow"
                      ref={modalRef}
                    >
                      <div className="modal-body text-body-emphasis p-4">
                        <h5 className="fw-bold mb-3">Add Stock</h5>
                        <p className="mb-4 ">
                          Are you sure you want to add{" "}
                          <strong>{finalData?.symbol || ""} </strong> (
                          {finalData?.qty || 0} Qty.) at{" "}
                          <strong>₹{finalData?.avgPrice || 0}</strong> price to
                          your portfolio?
                        </p>
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            className="btn btn-primary  py-2 rounded-3"
                            onClick={() => handleSave(finalData)}
                          >
                            Continue
                          </button>
                          <button
                            className="btn btn-outline-secondary  py-2 rounded-3"
                            onClick={() => setShowModal(false)}
                          >
                            Not Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>}
          </div>
        </div>
      ) : (
        <div className="py-3">
          <div className="container">
            <div className="row mt-4 ">
              <div className="col-md-12">
                <p className="my-3 d-none">
                  <small className="py-2 px-3 bg-opacity-10 my-3 shadow-sm">
                    🔔 <i>New Recommendations</i>
                  </small>
                </p>

                <div className="bg-success bg-opacity-10 p-2 border-bottom d-none d-md-block">
                  <div className="row">
                    <div className="col-md-2 col-3 small text-muted">Scrip</div>
                    <div className="col-md-2 col-6 small text-muted">
                      Fund Allocation
                    </div>
                    <div className="col-md-1 col-3 small text-muted">CMP</div>
                    <div className="col-md-1 col-3 small text-muted">
                      Recomm. Qty
                    </div>
                    <div className="col-md-1 col-12 small text-muted">
                    </div>
                    <div className="col-md-2 col-6 small text-muted">
                      Bought At
                    </div>
                    <div className="col-md-2 col-6 small text-muted">Qty.</div>
                    <div className="col-md-1 col-12 small"></div>
                  </div>
                </div>
                {userPortFolioList?.map((stock, index) => (
                  <>
                    <div
                      style={{
                        transition: "background-color 1s ease",
                        backgroundColor: highlightIndex === index
                          ? (localStorage.getItem("theme") === "dark" ? "#151515" : "#D7D7D7")
                          : "transparent",
                      }}
                      className={`${stock.investedAmt > 0 ? "" : "bg-success bg-opacity-10"
                        } p-2 border-bottom`}

                    >
                      <div
                        key={index}
                        className="row g-3 mb-2 align-items-center"
                      >
                        <div className="col-md-2 col-6">
                          <small className=" d-block d-md-none">
                            Symbol
                          </small>
                          <h6 className="mb-0 fw-bold text-body-emphasis">
                            {stock.symbol}
                          </h6>
                          <span className=" ">{stock.name}</span>
                        </div>

                        <div className="col-md-2 col-6">
                          <small className=" d-block d-md-none">
                            Fund Allocation
                          </small>
                          <span className="d-flex justify-content-between ">
                            <span className="">
                              
                              ₹
                              {/* {(
                                (Number(stock?.ltp) || 0) *
                                Math.floor((Number(stock?.allocation_amount) || 0) / (Number(stock?.ltp) || 1))
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} */}
                              {
                                (
                                  (Number(stock?.ltp) || 0) *
                                  Math.floor((Number(stock?.allocation_amount) || 0) / (Number(stock?.ltp) || 1))
                                ).toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              }
                              {/* {Number(stock.allocation_amount).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )} */}
                              {/* <span className="ms-1">
                                ({stock.allocation}%)
                              </span> */}
                            </span>
                          </span>
                        </div>

                        <div className="col-md-1 col-6">
                          <small className="text-muted d-block d-md-none">
                            CMP
                          </small>
                          <p className="mb-0">
                            {stock.ltp != null
                              ? Number(stock.ltp).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "--"}
                          </p>
                        </div>
                        <div className="col-md-1 col-6">
                          <small className="text-muted d-block d-md-none">
                            Recomm. Qty.
                          </small>
                          <p className=" mb-0">
                            {Math.floor(
                              stock.allocation_amount / stock.ltp
                            )?.toLocaleString("en-IN")}
                          </p>
                        </div>
                        <div className="col-md-1 col-12 d-flex justify-content-md-start justify-content-center">

                          {/* {((stock.investedAmt == 0 && !addedRows[index]) || editIndex === index) && (
                            <>
                              <ArrowRight
                                className="d-none d-md-block"
                                onClick={() => {
                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      qty: Math.floor(Number(stock.allocation_amount) / Number(stock.ltp)).toLocaleString("en-IN"),
                                      price: Number(stock.ltp).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  }));
                                }}
                              />

                              <ArrowDown
                                className="d-block d-md-none"
                                onClick={() => {
                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      qty: Math.floor(Number(stock.allocation_amount) / Number(stock.ltp)).toLocaleString("en-IN"),
                                      price: Number(stock.ltp).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  }));
                                }}
                              />
                            </>
                          )} */}
                          {((stock.investedAmt == 0 && !addedRows[index]) || editIndex === index) && (
                            <>
                              <button
                                className="btn btn-outline-secondary rounded-2 d-none d-md-inline-flex align-items-center justify-content-center shadow-sm"
                                // style={{ width: "40px", height: "40px" }}
                                onClick={() => {
                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      qty: Math.floor(Number(stock.allocation_amount) / Number(stock.ltp)).toLocaleString("en-IN"),
                                      price: Number(stock.ltp).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  }));
                                }}
                              >
                                <ArrowRight size={18} />
                              </button>

                              <button
                                className="btn btn-outline-secondary rounded-2 d-inline-flex d-md-none align-items-center justify-content-center shadow-sm"
                                // style={{ width: "40px", height: "40px" }}
                                onClick={() => {
                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: {
                                      ...prev[index],
                                      qty: Math.floor(Number(stock.allocation_amount) / Number(stock.ltp)).toLocaleString("en-IN"),
                                      price: Number(stock.ltp).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  }));
                                }}
                              >
                                <ArrowDown size={18} />
                              </button>
                            </>
                          )}


                        </div>
                        {(stock.investedAmt == 0 && !addedRows[index]) ? (
                          // ================== ADD MODE ==================
                          <>
                            <div className="col-md-2 col-6">
                              <small className="d-block d-md-none">Bought At</small>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors[index]?.price ? "is-invalid" : ""
                                  }`}
                                value={inputs[index]?.price || ""}
                                onChange={(e) => handleInputChange(index, "price", e.target.value, Math.floor(
                                  stock.allocation_amount / stock.ltp
                                ))}
                              />
                              {errors[index]?.price && (
                                <div className="invalid-feedback">{errors[index].price}</div>
                              )}
                            </div>
                            <div className="col-md-2 col-6">
                              <small className="text-muted d-block d-md-none">Qty.</small>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors[index]?.qty ? "is-invalid" : ""
                                  }`}
                                value={inputs[index]?.qty || ""}
                                onChange={(e) => handleInputChange(index, "qty", e.target.value, Math.floor(
                                  stock.allocation_amount / stock.ltp
                                ))}
                              />
                              {errors[index]?.qty && (
                                <div className="invalid-feedback">{errors[index].qty}</div>
                              )}
                            </div>


                            <div className="col-md-1 col-12">
                              <button
                                className="btn btn-sm w-100 bg-success"
                                onClick={() => handleAdd(stock, index, true, "add")}
                              // style={{ background: "#15C774" }}
                              >
                                <i className="fa fa-plus"></i> Add
                              </button>
                            </div>
                          </>
                        ) : editIndex === index ? (
                          // ================== EDIT MODE ==================
                          <>

                            <div className="col-md-2 col-6">
                              <small className="d-block d-md-none">Bought At</small>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors[index]?.price ? "is-invalid" : ""
                                  }`}
                                value={inputs[index]?.price ?? stock.avgPrice}
                                onChange={(e) => handleInputChange(index, "price", e.target.value, Math.floor(
                                  stock.allocation_amount / stock.ltp
                                ))}
                              />
                              {errors[index]?.price && (
                                <div className="invalid-feedback">{errors[index].price}</div>
                              )}
                            </div>
                            <div className="col-md-2 col-6">
                              <small className="text-muted d-block d-md-none">Qty.</small>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors[index]?.qty ? "is-invalid" : ""
                                  }`}
                                value={inputs[index]?.qty ?? stock.qty}
                                onChange={(e) => handleInputChange(index, "qty", e.target.value, Math.floor(
                                  stock.allocation_amount / stock.ltp
                                ))}
                              />
                              {errors[index]?.qty && (
                                <div className="invalid-feedback">{errors[index].qty}</div>
                              )}
                            </div>
                            <div className="col-md-1 col-12">
                              <button
                                className="btn btn-sm w-100 bg-primary"
                                onClick={() => {
                                  handleAdd(stock, index, true, "edit");
                                  setEditIndex(null); // exit edit mode
                                }}
                              // style={{ background: "#0d6efd" }}
                              >
                                <i className="fa fa-save"></i> Save
                              </button>
                            </div>
                          </>
                        ) : (
                          // ================== VIEW MODE ==================
                          <>

                            <div className="col-md-2 col-6">
                              <small className="d-block d-md-none">Bought At</small>
                              {stock.avgPrice}
                            </div>
                            <div className="col-md-2 col-6">
                              <small className="text-muted d-block d-md-none">Qty.</small>
                              {stock.qty}
                            </div>

                            <div className="col-md-1 col-12">
                              <button
                                className="btn btn-sm w-100 bg-warning"

                                onClick={(e) => {

                                  setInputs((prev) => ({
                                    ...prev,
                                    [index]: { qty: stock.qty, price: stock.avgPrice },
                                  }));
                                  setEditIndex(index);
                                }}
                              // style={{ background: "#e0a800" }}
                              >
                                <i className="fa fa-edit"></i> Edit
                              </button>
                            </div>
                          </>
                        )}

                      </div>
                    </div >
                    <p className="d-block d-md-none"></p>
                  </>
                ))}
                {userDetail.wealthInvestmentAmt && userDetail.multibaggerAllocation && <>
                  {userPortFolioList?.every((item) => item.qty !== 0) && (
                    <div className="text-center">
                      <button
                        className="btn btn-sm btn-primary w-10 bg-gradient mt-4"
                        onClick={() => {
                          navigate("/dashboard");
                          dispatch(setInitialuserDetail());
                        }}
                      >
                        Go to Dashboard
                      </button>
                    </div>
                  )}
                </>}
              </div>
              {showModal && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div
                      className="modal-content text-center rounded-4 shadow"
                      ref={modalRef}
                    >
                      <div className="modal-body p-4">
                        <h5 className="fw-bold mb-3">Add Stock</h5>
                        <p className="mb-4 ">
                          Are you sure you want to add{" "}
                          <strong>{finalData?.symbol || ""} </strong> (
                          {finalData?.qty || 0} Qty.) at{" "}
                          <strong>₹{finalData?.avgPrice || 0}</strong> price to
                          your portfolio?
                        </p>
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            className="btn btn-primary  py-2 rounded-3"
                            onClick={() => handleSave(finalData)}
                          >
                            Continue
                          </button>
                          <button
                            className="btn btn-outline-secondary  py-2 rounded-3 text-body-emphasis"
                            onClick={() => setShowModal(false)}
                          >
                            Not Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row g-3">
              <div className="col-md-12"></div>
            </div>
          </div>
        </div>
      )
      }
    </div >
  );
}
